var render, staticRenderFns
import script from "./EventEditLoad.vue?vue&type=script&lang=js&"
export * from "./EventEditLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218a49a",
  null
  
)

export default component.exports